/** Clayo.io frontend colors for Ant Design (awb-color4 / awb-color5 / awb-color8) */
export const ANALYTICS_DATE_PICKER_CLASS = "analytics-date-picker";

export const analyticsAntTheme = {
  token: {
    colorPrimary: "#00C074",
    colorPrimaryHover: "#006B44",
    colorPrimaryActive: "#006766",
    colorLink: "#00C074",
    colorLinkHover: "#006B44",
  },
  components: {
    DatePicker: {
      activeBorderColor: "#00C074",
      hoverBorderColor: "#006B44",
      cellActiveWithRangeBg: "rgba(0, 192, 116, 0.14)",
      cellHoverWithRangeBg: "rgba(0, 192, 116, 0.08)",
      cellHoverBg: "rgba(0, 192, 116, 0.08)",
    },
  },
};
